import React from 'react';

import { getValueFromEventContainingOnlyNumeric } from 'components/BaseForm/utils';
import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FormFilterFieldCentreVHU } from '../../types';

function InputSiren({ values }: FormFilterFieldCentreVHU): React.ReactElement {
  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: 'siren',
        itemProps: {
          label: 'SIREN',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
          getValueFromEvent: getValueFromEventContainingOnlyNumeric,
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Number }}
    />
  );
}

export default InputSiren;
